export default {
	site: "站点",
	role: "角色",
	submitTime: "提交时间",
	exportTime: "导出时间",
	exportStatus: "导出状态",
	exported: "已导出",
	notExported: "未导出"
};
